

















import Vue from 'vue';
import CardInfo from '@/components/card/CardInfo.vue';
import { Component, Prop } from 'vue-property-decorator';
import { PokemonTCG } from 'pokemon-tcg-sdk-typescript';
import { DECKLIST, MODAL } from '@/store/actions';
import { CardBundle } from '@/types/bundle';

@Component({
  components: {
    CardInfo,
  },
})
export default class Card extends Vue {
  @Prop() public bundle!: CardBundle;

  get card(): PokemonTCG.Card {
    return this.bundle.card;
  }

  get cropHeight(): string {
    switch (this.card.supertype) {
      case 'Trainer':
        return '-80px';
      case 'Energy':
        switch (this.card.subtype) {
          case 'Basic': return '-180px';
          case 'Special': return '-120px';
          default: return '-180px';
        }
      default:
        return '-40px';
    }
  }

  get cropStyle(): string {
    return `
      background: url(${this.card.imageUrl});
      background-repeat: no-repeat;
      background-position: -24px ${this.cropHeight};
      `;
  }

  private showCardInfo() {
    this.$store.commit(MODAL.SET_CLOSE_INFO_NORMAL);
    this.$store.commit(MODAL.SET_CARD_INFO, this.card);
    this.$store.dispatch(MODAL.LOAD_CARD_PRICE, this.card.id);
    this.$router.push({ path: this.$route.name || undefined, query: { card: this.card.id }});
  }

  private addCard() {
    this.$store.commit(DECKLIST.ADD_CARD, this.card);
  }

  private removeCard() {
    this.$store.commit(DECKLIST.REMOVE_CARD, this.card);
  }
}
